import { render, staticRenderFns } from "./siderBar.vue?vue&type=template&id=34cf6bd6&scoped=true&"
import script from "./siderBar.vue?vue&type=script&lang=js&"
export * from "./siderBar.vue?vue&type=script&lang=js&"
import style0 from "./siderBar.vue?vue&type=style&index=0&id=34cf6bd6&lang=scss&scoped=true&"
import style1 from "./siderBar.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34cf6bd6",
  null
  
)

export default component.exports